import type { Organism } from '@verndale/core';
import globModules from './glob-modules';
import modulesReact from './modules-react';

const modules: Organism[] = [
  {
    name: 'accordion',
    loader: () => import('./modules/accordion')
  },
  {
    name: 'search-header',
    loader: () => import('./modules/search-header')
  },
  {
    name: 'GalleryModal',
    loader: () => import('./modules/gallery-modal')
  },
  {
    name: 'rtfModal',
    loader: () => import('./modules/rtf-modal')
  }
];

export default [...globModules, ...modules, ...modulesReact];
